import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksVendorFields.PaymentDetailsSection', {
    header: 'Payment details',
    accountNo: 'Account No.',
    bankAccountName: 'Bank account name',
    bsb: 'BSB',
    bankAccountNumber: 'Bank account number',
    statement: 'Statement text',
});
